// User/Profile.tsx

import React from 'react';
import {NavLink, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import {useTheme} from "Theme/ThemeContext";
import TabButton from "Core/components/elements/Tabs/TabButton";
import ClientPersonalInfoForm from "Client/ClientPersonalInfoForm";
import PsychologistWorkParamsForm from "Psychologist/PsychologistWorkParamsForm";
import {FC, FRS} from "WideLayout/Layouts";
import UserPersonalInfoForm from "User/UserPersonalInfoForm";
import {DOMAIN_URL} from "Auth/axiosConfig";
import Head from "Core/components/Head";

interface ProfileProps {
    selectedProfile: 'client' | 'psychologist';
}

const Profile: React.FC<ProfileProps> = ({selectedProfile}) => {
    const {plt} = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    // Определяем активные маршруты для вкладок
    const basePath = '/profile';
    const currentPath = location.pathname;

    // Определяем вкладки в зависимости от выбранного профиля
    const tabs = selectedProfile === 'client' ? [
        {label: 'Пользователь', path: `${basePath}/user`},
        // {label: 'Клиент', path: `${basePath}/client`}, // Будет видео профиль клиента
    ] : [
        {label: 'Пользователь', path: `${basePath}/user`},
        {label: 'Психолог', path: `${basePath}/psychologist`},
    ];

    // Если пользователь находится на /profile, перенаправляем на первую вкладку
    React.useEffect(() => {
        if (currentPath === basePath || currentPath === `${basePath}/`) {
            navigate(tabs[0].path);
        }
    }, [currentPath, navigate, tabs]);

    return (
        <><Head
            title={'Профиль | Лайф Хелп'}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/profile`}/><FC h={'100%'}>
            <FRS g={2} px={3} pt={2}>
                {tabs.map((tab) => (
                    <NavLink key={tab.path} to={tab.path} style={{textDecoration: 'none'}}>
                        {({isActive}) => (
                            <TabButton fontSize={'1.3rem'} textSx={{padding: '0 .7rem'}} active={isActive}>
                                {tab.label}
                            </TabButton>
                        )}
                    </NavLink>
                ))}
            </FRS>
            <FC grow scroll={'y-auto'} px={3} py={1}>
                <Routes>
                    <Route path="user" element={<UserPersonalInfoForm/>}/>
                    {selectedProfile === 'client' && (
                        <Route path="client" element={<ClientPersonalInfoForm/>}/>
                    )}
                    {selectedProfile === 'psychologist' && (
                        <Route path="psychologist" element={<PsychologistWorkParamsForm/>}/>
                    )}
                </Routes>
            </FC>
        </FC></>
    );
};

export default Profile;
